import { useQuery } from '@apollo/client/react';

import { GET_MAP_ASSETS_FILTER } from '@atom/graph/map';
import { usePreferences } from '@atom/hooks/usePreferences';
import { EMPTY_MAP_DATA } from '@atom/map';
import {
  InventoryMapFilters,
  MapAssetsFilterInput,
  MapData,
} from '@atom/types/map';
import { formatAssetAttributeFilters } from '@atom/utilities/assetUtilities';

type UseInventoryMapDataArgs = InventoryMapFilters & {
  coordinates: string;
  zoomLevel: number;
};

export const useInventoryMapData = ({
  coordinates,
  zoomLevel,
  categoryIds,
  schemaId,
  hasPendingChangesOnly,
  assetFilters,
}: UseInventoryMapDataArgs): [MapData, boolean] => {
  const clusterDensity = usePreferences().map?.clusterDensity ?? 'default';

  const input: MapAssetsFilterInput = {
    coordinates: coordinates ? (JSON.parse(coordinates) as number[][][]) : [],
    zoomLevel,
    clusterDensity,
    schemaId: schemaId || undefined,
    categoryIds: categoryIds ? categoryIds.split(',') : undefined,
    hasPendingChangesOnly,
    attributeFilters: formatAssetAttributeFilters(assetFilters),
  };

  const { data, previousData, loading } = useQuery(GET_MAP_ASSETS_FILTER, {
    variables: { input },
    skip: !coordinates,
    fetchPolicy: 'network-only',
  });

  return [
    data?.mapAssetsFilter ?? previousData?.mapAssetsFilter ?? EMPTY_MAP_DATA,
    loading,
  ];
};
